import { queryParams } from "../../../utils/queryParams";

export default {
  START_FROM_OPTIONS: [
    { id: "leads", name: "Lead (Profile Creation)" },
    { id: "appointments", name: "Appointment (First Booking)" },
    { id: "shows", name: "Show (First Visit)" },
    { id: "enrollments", name: "Enrollment (First Qualifying Purchase)" },
    { id: "introOffer", name: "Intro Offer (Introductory Offer Purchase)" }
  ],

  AVERAGE_OPTIONS: ["Not Selected", "Network", "Division", "District", "Region"],

  REQUEST_HREF: {
    FUNNEL_LASER_CHART: `${queryParams.apiVersion}pages/sales_activity/laser/funnel_laser_chart/get_chart`,
    FUNNEL_INTRO_OFFER: `${queryParams.apiVersion}pages/sales_activity/laser/funnel_laser_chart/get_start_from_intro`,
    FUNNEL_TABLE: `${queryParams.apiVersion}pages/sales_activity/laser/funnel_laser_chart/referrals`,
    FUNNEL_LASER_CHART_FILTERS: `${queryParams.apiVersion}pages/sales_activity/laser/funnel_laser_chart/get_filters`
  }
};

export const BOOKING_COUNTING_STATUSES = [
  {
    status: "Open Booking",
    description: " - Not yet a completed booking",
    appointment: "COUNT",
    show: "DO NOT COUNT"
  },
  {
    status: "Cancelled Within Policy Rules",
    description: " - No session credit lost",
    appointment: "DO NOT COUNT",
    show: "DO NOT COUNT"
  },
  {
    status: "Cancelled Outside Policy Rules",
    description: " - Session Lost",
    appointment: "COUNT",
    show: "DO NOT COUNT"
  },
  {
    status: "Cancelled By Admin",
    description: " - Not Customer Fault - No Session Credit Lost",
    appointment: "DO NOT COUNT",
    show: "DO NOT COUNT"
  },
  {
    status: "Completed Booking",
    description: "",
    appointment: "COUNT",
    show: "COUNT AS SHOW"
  },
  {
    status: "No Show Booking",
    description: " - Client didn't come",
    appointment: "COUNT",
    show: "DO NOT COUNT"
  },
  {
    status: "Rescheduled Within Policy Rules",
    description: " - No session credit lost",
    appointment: "COUNT",
    show: "N/A"
  },
  {
    status: "Rescheduled By Admin",
    description: "",
    appointment: "COUNT",
    show: "N/A"
  },
  {
    status: "Pending",
    description: " – Similar (same) to open booking",
    appointment: "COUNT",
    show: "DO NOT COUNT"
  },
  {
    status: "WaitListed",
    description: "",
    appointment: "DO NOT COUNT",
    show: "DO NOT COUNT"
  }
];
